"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const IsCustomerFollowingSellerQuery = (0, graphql_tag_1.default) `
  query IsCustomerFollowingSeller($sellerId: String!, $customerId: String!) {
    isCustomerFollowingSeller(request: { sellerId: $sellerId, customerId: $customerId }) {
      ... on FollowerErrorResponse {
        message
        detail
      }
      ... on FollowerFollowingSellerResponse {
        customerId
        sellerId
        isFollowing
      }
    }
  }
`;
exports.default = IsCustomerFollowingSellerQuery;
